import React from "react";
import { Chip, ChipProps } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelIcon from "@mui/icons-material/Cancel";

import { InstanceStatus } from "../../types";

interface StatusBadgeProps {
  status: InstanceStatus;
  size?: "small" | "medium";
  showIcon?: boolean;
}

const statusConfig: Record<
  InstanceStatus,
  { label: string; color: ChipProps["color"]; icon: React.ReactElement }
> = {
  PENDING: {
    label: "Pending",
    color: "warning",
    icon: <HourglassEmptyIcon fontSize="small" />,
  },
  PROVISIONING: {
    label: "Provisioning",
    color: "info",
    icon: <PauseCircleIcon fontSize="small" />,
  },
  RUNNING: {
    label: "Running",
    color: "success",
    icon: <PlayCircleIcon fontSize="small" />,
  },
  FAILED: {
    label: "Failed",
    color: "error",
    icon: <ErrorIcon fontSize="small" />,
  },
  EXPIRED: {
    label: "Expired",
    color: "default",
    icon: <CheckCircleIcon fontSize="small" />,
  },
  TERMINATED: {
    label: "Terminated",
    color: "default",
    icon: <CancelIcon fontSize="small" />,
  },
  STOPPED: {
    label: "Stopped",
    color: "warning",
    icon: <StopCircleIcon fontSize="small" />,
  },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = "small",
  showIcon = true,
}) => {
  const config = statusConfig[status] || statusConfig.PENDING;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={showIcon ? config.icon : undefined}
      sx={{
        fontWeight: 500,
        "& .MuiChip-icon": {
          fontSize: size === "small" ? 16 : 20,
        },
      }}
    />
  );
};

export default StatusBadge;
